import { ObjectConfig, required } from "@homebound/form-state";
import { ChangeEventWorkflow } from "src/generated/graphqlTypes";
import { GuidedChangeEventStep } from "src/routes/projects/change-events/guided/utils";
import { reviewImpactStep, reviewStep } from "src/routes/projects/change-events/guided/workflows/sharedSteps";
import { SelectProductToReplaceStep } from "src/routes/projects/change-events/guided/workflows/swapProductCatalog/2.SelectProductToReplaceStep";
import { defineWorkflow } from "src/routes/projects/change-events/guided/workflows/types";

export type SwapProductInCatalogFormInput = {
  swaps: { originalProjectItemId?: string | null; replacementMaterialVariantId?: string | null }[];
};

// Exported so tests can build their form state from the same config the runner uses.
export const swapProductInCatalogFormConfig: ObjectConfig<SwapProductInCatalogFormInput> = {
  swaps: {
    type: "list",
    rules: [
      // At least one swap is needed to create the change event
      required,
      // Every swap must have an original and replacement product
      ({ value }) =>
        !value.every((swap) => !!swap.originalProjectItemId.value && !!swap.replacementMaterialVariantId.value)
          ? "Every swap must have an original and replacement product"
          : undefined,
    ],
    config: {
      originalProjectItemId: { type: "value", rules: [required] },
      replacementMaterialVariantId: { type: "value", rules: [required] },
    },
  },
};

export const swapProductInCatalogWorkflow = defineWorkflow<SwapProductInCatalogFormInput>({
  workflow: ChangeEventWorkflow.SwapProductInCatalog,
  formConfig: swapProductInCatalogFormConfig,
  steps: [
    {
      value: GuidedChangeEventStep.SelectProductToReplace,
      label: "Select Product to Replace",
      isComplete: (form) => form.valid,
      render: (form) => <SelectProductToReplaceStep formState={form} />,
    },
    reviewImpactStep(),
    reviewStep(),
  ],
  useActions: () => {
    return {
      // TODO: submit the change event for the swap-product-in-catalog flow.
      onSubmit: async () => {},
    };
  },
});
